module.exports = __webpack_public_path__ + "img/plus_hover.f285b6e1.svg";